import { KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

export function mapQuote(
  input: QuoteFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'Quote'> {
  return {
    key: 'Quote',
    input,
  };
}
